import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { IconButton, InputBase, type InputBaseProps } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

const SearchWrapper = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(
    theme.palette.mode === "dark"
      ? theme.palette.common.white
      : theme.palette.common.black,
    0.15
  ),
  display: "flex",
  flexDirection: "row",
  "&:hover": {
    backgroundColor: alpha(
      theme.palette.mode === "dark"
        ? theme.palette.common.white
        : theme.palette.common.black,
      0.25
    ),
  },
  alignItems: "center",
  marginLeft: 0,
  width: "100%",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    transition: (theme.transitions as any).create("width"),
    width: "100%",
  },
}));

export const SearchBar: React.FC<InputBaseProps> = ({
  placeholder,
  sx,
  ...rest
}) => {
  const shouldShowCancelIcon = !!rest.value;

  const onCancelIconClick = () => {
    rest.onChange?.({ target: { value: "" } } as any);
  };

  return (
    <SearchWrapper sx={sx} data-testid="search-bar">
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <StyledInputBase
        {...(rest as any)}
        inputProps={{ "aria-label": "search" }}
        placeholder={placeholder || "Search..."}
      />
      {shouldShowCancelIcon ? (
        <IconButton
          disableRipple
          sx={(theme) => ({
            padding: theme.spacing(0, 2),
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          })}
          onClick={onCancelIconClick}
          aria-label="clear search"
        >
          <CancelIcon />
        </IconButton>
      ) : null}
    </SearchWrapper>
  );
};
